<div fxLayout="row" class="main-box">
    <div fxFlex="4" fxLayout="column" class="left-most-icon">
        <div style="width: 100%; height: 8%; background: white; border-radius: 9999px; padding: 15px;margin-bottom: 10px;" routerLink="/admin/social-hub/post-hub">
            <img style="width: 1.25rem;;height: 1.25rem; margin-bottom: 8px;" src="assets/post-icon.svg">
        </div>
        <div style="width: 100%; height: 8%; background: #E3EAFF; border-radius: 9999px; padding: 15px;">
            <img style="width: 1.25rem;;height: 1.25rem" src="assets/competition-icon.svg">
        </div>
    </div>
    <div fxFlex="70" class="middle-box">
        <div style="background: #E1E9FE;padding: 10px; margin-bottom: 15px;">
            <img src="assets/back-icon.svg" style="margin-right: 7px; cursor: pointer;"
            routerLink="/admin//social-hub/competition-zone" >  
            <span class="create-competition-text">Create Competition</span>
        </div>
        <div style="padding: 10px;" fxLayout="column">
            <span class="heading-language">Select Language </span>
            <mat-form-field [floatLabel]="'never'"
                style="background-color: white;width: 23%;height:49px;text-align: center;border-radius: 8px; border: 1px #ECECEC solid; padding-right: 8px; margin-bottom: 10px;">
                <mat-label class="drop-downtext">Select Language</mat-label>
                <mat-select [formControl]="selectedLanguages" name="food" multiple
                    (openedChange)="triggerSelectLanguage($event)">
                    <mat-option *ngFor="let language of languages" [value]="language">
                        {{language}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <div class="brown-fillling-area">
                <div fxLayout="row" style="margin-bottom: 10px;">
                    <button class="language-button-outline" *ngFor="let language of selectedLanguageForShow"  [ngStyle]="editingLanguage == language && {'background': '#E3ECFB'}"
                        mat-stroked-button (click)="changeLanguage(language)" >
                        <span class="language-button-text">{{language}}</span>
                    </button>
                </div>
                <div class="form-text-label">Add Name*</div>
                <mat-form-field [floatLabel]="'never'" [formGroup]="createCompetitionForm" style="width: 300px;">
                    <mat-label *ngIf="createCompetitionForm.controls[nameForm].value.length==0 || createCompetitionForm.controls[nameForm].value=='  '"
                      style="color: #999999; font-size: 14px; font-family: Montserrat; font-weight: 400; letter-spacing: 0.20px; word-wrap: break-word">Type
                      here</mat-label>
                    <textarea *ngIf="nameForm == 'name'" style="height: 18px; overflow-y: auto; scroll-behavior: smooth;" #message maxlength="28"
                      minlength="2" matInput  formControlName="name"></textarea>
                    <textarea *ngIf="nameForm == 'hindiName'" style="height: 18px; overflow-y: auto; scroll-behavior: smooth;" #message maxlength="28"
                      minlength="2" matInput  formControlName="hindiName"></textarea>
                    <textarea *ngIf="nameForm == 'gujName'" style="height: 18px; overflow-y: auto; scroll-behavior: smooth;" #message maxlength="28"
                      minlength="2" matInput  formControlName="gujName"></textarea>
                    <textarea *ngIf="nameForm == 'telName'" style="height: 18px; overflow-y: auto; scroll-behavior: smooth;" #message maxlength="28"
                      minlength="2" matInput  formControlName="telName"></textarea>
                    <textarea *ngIf="nameForm == 'marName'" style="height: 18px; overflow-y: auto; scroll-behavior: smooth;" #message maxlength="28"
                      minlength="2" matInput  formControlName="marName"></textarea>
                    <mat-hint align="end">{{ createCompetitionForm.controls[nameForm].value.length }} / 28</mat-hint>
                    <mat-error *ngIf="!createCompetitionForm.controls[nameForm].valid && createCompetitionForm.controls[nameForm].touched">
                      {{ getErrorName() }}
                    </mat-error>
                  </mat-form-field>
                <div fxLayout="row" style="margin-top: 10px;justify-content: space-between; ">
                    <span class="form-text-label">Add Poster*</span>
                    <img *ngIf="!toggleExpandIcon[0]" src="assets/plus.svg" style="cursor: pointer;"
                        (click)="expandField(0)">
                    <img *ngIf="toggleExpandIcon[0]" src="assets/minus.svg" style="cursor: pointer;"
                        (click)="expandField(0)">

                </div>
                <div *ngIf="toggleExpandIcon[0]">
                    <div fxLayout="row" (click)="triggerLandScapeInput.click()"
                        style="width: 40%; height: 68px; margin-top: 7px; margin-bottom: 7px; padding-left: 24px; padding-right: 24px; padding-top: 12px; padding-bottom: 12px; border-radius: 10px; border: 1px #386AF6 dotted; justify-content: center; align-items: center; gap: 4px; cursor: pointer;">
                        <img src="assets/upload.svg">
                        <div *ngIf="!isUploaded || fileSize > 1000000"><span
                                style="color: #0E0E0E; font-size: 12px; font-family: Montserrat; font-weight: 500; line-height: 17px; word-wrap: break-word">Drag
                                and drop or</span><span
                                style="color: #386AF6; font-size: 12px; font-family: Montserrat; font-weight: 500; line-height: 17px; word-wrap: break-word">
                                Upload Landscape</span>
                            <div
                                style="color: #696969; font-size: 9px; font-family: Montserrat; font-weight: 400; line-height: 12.60px; word-wrap: break-word">
                                Upload Image upto 1MB, 360 X 164px, JPG or PNG</div>
                        </div>
                        <input #triggerLandScapeInput type="file" accept=".jpg, .png"
                            (change)="handleLandScapePosterChange($event)" style="display: none;" />
                        <div
                            style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
                            <div *ngIf="isUploaded && fileSize <= 1000000">
                                <span
                                    style="color: #0E0E0E; font-size: 12px; font-family: Montserrat; font-weight: 500; word-wrap: break-word;">
                                    Landscape image Selected
                                </span>
                            </div>
                            <div style="display: flex; gap: 5px;">
                                <span
                                    style="font-size: 12px; font-family: Montserrat; font-weight: 500; color: #0E0E0E; word-wrap: break-word;">
                                    {{ createCompetitionForm.get('posterName').value.length > 28 ?
                                    (createCompetitionForm.get('posterName').value | slice:0:26) + '..' :
                                    createCompetitionForm.get('posterName').value }}
                                </span>
                                <span *ngIf="isUploaded && createCompetitionForm.get('posterName').value.length > 28"
                                    style="font-size: 12px; font-family: Montserrat; font-weight: 500; color: #0E0E0E;">
                                    {{ createCompetitionForm.get('posterName').value.endsWith('.jpg') ? '.jpg' : '.png'
                                    }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div fxLayout="row" (click)="triggerPortraitInput.click()"
                        style="width: 40%; height: 68px; padding-left: 24px; padding-right: 24px; padding-top: 12px; padding-bottom: 12px; border-radius: 10px; border: 1px #386AF6 dotted; justify-content: center; align-items: center; gap: 8px; cursor: pointer;">
                        <img src="assets/upload.svg">
                        <div *ngIf="!isPortraitUploaded || portraitImageSize > 1000000"><span
                                style="color: #0E0E0E; font-size: 12px; font-family: Montserrat; font-weight: 500; line-height: 17px; word-wrap: break-word">Drag
                                and drop or</span><span
                                style="color: #386AF6; font-size: 12px; font-family: Montserrat; font-weight: 500; line-height: 17px; word-wrap: break-word">
                                Upload Portrait</span>
                            <div
                                style="color: #696969; font-size: 9px; font-family: Montserrat; font-weight: 400; line-height: 12.60px; word-wrap: break-word">
                                Upload Image upto 1MB, 115 X 140px, JPG or PNG</div>
                        </div>
                        <input #triggerPortraitInput type="file" accept=".jpg, .png"
                            (change)="handlePortraitPosterChange($event)" style="display: none;" />
                        <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
                            <div *ngIf="isPortraitUploaded && portraitImageSize <= 1000000">
                                <span
                                    style="color: #0E0E0E; font-size: 12px; font-family: Montserrat; font-weight: 500; word-wrap: break-word;">
                                    Portrait image Selected
                                </span>
                            </div>
                            <div style="display: flex; gap: 5px;">
                                <span
                                    style="font-size: 12px; font-family: Montserrat; font-weight: 500; color: #0E0E0E; word-wrap: break-word;">
                                    {{ createCompetitionForm.get('photoName').value.length > 28 ?
                                    (createCompetitionForm.get('photoName').value | slice:0:26) + '..' :
                                    createCompetitionForm.get('photoName').value }}
                                </span>
                                <span *ngIf="isPortraitUploaded && createCompetitionForm.get('photoName').value.length > 28"
                                    style="font-size: 12px; font-family: Montserrat; font-weight: 500; color: #0E0E0E;">
                                    {{ createCompetitionForm.get('photoName').value.endsWith('.jpg') ? '.jpg' : '.png'
                                    }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div fxLayout="row" style="margin-top: 25px;justify-content: space-between; ">
                    <span class="form-text-label">Add Video (Optional)</span>
                    <img *ngIf="!toggleExpandIcon[3]" src="assets/plus.svg" style="cursor: pointer;"
                        (click)="expandField(3)">
                    <img *ngIf="toggleExpandIcon[3]" src="assets/minus.svg" style="cursor: pointer;"
                        (click)="expandField(3)">

                </div>
                <div *ngIf="toggleExpandIcon[3]">
                    <div [formGroup]="createCompetitionForm" >
                        <input class="video-url-input" type="text" formControlName="bannerVideoLink" placeholder="Enter video URL">
                    </div>
                </div>
                <div fxLayout="row" style="margin-top: 25px;justify-content: space-between; ">
                    <span class="form-text-label">Add Details*</span>
                    <img *ngIf="!toggleExpandIcon[1]" src="assets/plus.svg" style="cursor: pointer;"
                        (click)="expandField(1)">
                    <img *ngIf="toggleExpandIcon[1]" src="assets/minus.svg" style="cursor: pointer;"
                        (click)="expandField(1)">
                </div>

                <div *ngIf="toggleExpandIcon[1]">
                    <div [formGroup]="createCompetitionForm" fxLayout="column">
                        <span class="form-sub-text-label">Add Brief*</span>
                        <div [innerHtml]="createCompetitionForm.get(detailForm).value" style="margin-bottom: 8px;">
                        </div>
                            <ckeditor *ngIf="detailForm == 'deatailsBrief'" tagName="textarea" [editor]="Editor"  formControlName="deatailsBrief"></ckeditor>
                            <ckeditor *ngIf="detailForm == 'hindideatailsBrief'" tagName="textarea" [editor]="Editor"  formControlName="hindideatailsBrief"></ckeditor>
                            <ckeditor *ngIf="detailForm == 'gujdeatailsBrief'" tagName="textarea" [editor]="Editor"  formControlName="gujdeatailsBrief"></ckeditor>
                            <ckeditor *ngIf="detailForm == 'teldeatailsBrief'" tagName="textarea" [editor]="Editor"  formControlName="teldeatailsBrief"></ckeditor>
                            <ckeditor *ngIf="detailForm == 'mardeatailsBrief'" tagName="textarea" [editor]="Editor"  formControlName="mardeatailsBrief"></ckeditor>
                            <p style="display: flex;flex-direction: row-reverse;color: rgba(0,0,0,.54);font-weight: 400;font-family: Roboto, Helvetica Neue, sans-serif;letter-spacing: normal;height: 1px;">{{getlengthOfDetails()}} /1000 </p>
                        <span class="form-sub-text-label">Add Instruction details*</span>
                        <div [innerHtml]="createCompetitionForm.get(instructionForm).value" style="margin-bottom: 8px;"></div>
                        <ckeditor *ngIf="instructionForm == 'instruction'" tagName="textarea" [editor]="Editor"  formControlName="instruction"></ckeditor>
                        <ckeditor *ngIf="instructionForm == 'hindiinstruction'" tagName="textarea" [editor]="Editor"  formControlName="hindiinstruction"></ckeditor>
                        <ckeditor *ngIf="instructionForm == 'gujinstruction'" tagName="textarea" [editor]="Editor"  formControlName="gujinstruction"></ckeditor>
                        <ckeditor *ngIf="instructionForm == 'telinstruction'" tagName="textarea" [editor]="Editor"  formControlName="telinstruction"></ckeditor>
                        <ckeditor *ngIf="instructionForm == 'marinstruction'" tagName="textarea" [editor]="Editor"  formControlName="marinstruction"></ckeditor>
                        <p style="display: flex;flex-direction: row-reverse;color: rgba(0,0,0,.54);font-weight: 400;font-family: Roboto, Helvetica Neue, sans-serif;letter-spacing: normal;height: 1px;">{{getlengthOfinstruction()}} /1000 </p>
                        <span class="form-sub-text-label">Add picture</span>
                        <div fxLayout="row" (click)="triggerDetailsPictureInput.click()"
                        style="width: 40%; height: 68px ;margin-top: 7px; margin-bottom: 7px; padding-left: 24px; padding-right: 24px; padding-top: 12px; padding-bottom: 12px; border-radius: 10px; border: 1px #386AF6 dotted; justify-content: center; align-items: center; gap: 8px; cursor: pointer;">
                        <img src="assets/upload.svg">
                        <div *ngIf="!isPictureUploaded || selectedPictureSize > 1000000"><span
                                style="color: #0E0E0E; font-size: 12px; font-family: Montserrat; font-weight: 500; line-height: 17px; word-wrap: break-word">Drag
                                and drop or</span><span
                                style="color: #386AF6; font-size: 12px; font-family: Montserrat; font-weight: 500; line-height: 17px; word-wrap: break-word">
                                Upload Picture</span>
                            <div
                                style="color: #696969; font-size: 9px; font-family: Montserrat; font-weight: 400; line-height: 12.60px; word-wrap: break-word">
                                Upload Image upto 1MB, 360 X 164px, JPG or PNG</div>
                        </div>
                        <input #triggerDetailsPictureInput type="file" accept=".jpg, .png"
                            (change)="handlePictureChange($event)" style="display: none;" />
                        <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
                            <div *ngIf="isPictureUploaded === true && selectedPictureSize <= 1000000">
                                <span style="color: #0E0E0E; font-size: 12px; font-family: Montserrat; font-weight: 500; word-wrap: break-word;">Picture Selected</span>
                            </div>
                            <div style="display: flex; gap: 5px;">
                                <span
                                    style="font-size: 12px; font-family: Montserrat; font-weight: 500; color: #0E0E0E; word-wrap: break-word;">
                                    {{ createCompetitionForm.get('details_poster_name').value.length > 28 ?
                                    (createCompetitionForm.get('details_poster_name').value | slice:0:26) + '..' :
                                    createCompetitionForm.get('details_poster_name').value }}
                                </span>
                                <span *ngIf="isPictureUploaded === true && createCompetitionForm.get('details_poster_name').value.length > 28"
                                    style="font-size: 12px; font-family: Montserrat; font-weight: 500; color: #0E0E0E;">
                                    {{ createCompetitionForm.get('details_poster_name').value.endsWith('.jpg') ? '.jpg' : '.png'
                                    }}
                                </span>
                            </div>
                        </div> 
                       </div>
                       <span class="form-sub-text-label">Add Note</span>
                        <mat-form-field [floatLabel]="'never'" style="width: 100%;">
                            <div [innerHtml]="createCompetitionForm.get(noteForm).value" style="margin-bottom: 8px;">
                            </div>
                            <mat-label *ngIf="createCompetitionForm.controls[noteForm].value.length==0 || createCompetitionForm.controls[noteForm].value=='  '"
                                style=" color: #999999; font-size: 14px; font-family: Montserrat; font-weight: 400; letter-spacing: 0.20px; word-wrap: break-word">Add
                                Note
                            </mat-label>
                            <textarea *ngIf="noteForm == 'note'" maxlength="150" style="background: white; border-radius: 5px;" matInput #note
                                formControlName="note"></textarea>
                            <textarea *ngIf="noteForm == 'hindiNote'" maxlength="150" style="background: white; border-radius: 5px;" matInput #note
                                formControlName="hindiNote"></textarea>
                            <textarea *ngIf="noteForm == 'gujNote'" maxlength="150" style="background: white; border-radius: 5px;" matInput #note
                                formControlName="gujNote"></textarea>
                            <textarea *ngIf="noteForm == 'telNote'" maxlength="150" style="background: white; border-radius: 5px;" matInput #note
                                formControlName="telNote"></textarea>
                            <textarea *ngIf="noteForm == 'marNote'" maxlength="150" style="background: white; border-radius: 5px;" matInput #note
                                formControlName="marNote"></textarea>
                            <mat-hint align="end">{{createCompetitionForm.controls[noteForm].value.length}} /150 </mat-hint>
                        </mat-form-field>
                    </div>

                </div>

            </div>
            <div fxLayout="row" style="margin-top: 25px;justify-content: space-between; ">
                <span class="form-text-label">Add Eligibility Details*</span>
                <img *ngIf="!toggleExpandIcon[2]" src="assets/plus.svg" style="cursor: pointer;"
                    (click)="expandField(2)">
                <img *ngIf="toggleExpandIcon[2]" src="assets/minus.svg" style="cursor: pointer;"
                    (click)="expandField(2)">
            </div>
            <div fxLayout="column" *ngIf="toggleExpandIcon[2]">
                <span class="form-sub-text-label" style="margin-top: 6px;">Class</span>
                <div class="custom-slider">
                    <ngx-slider style="width: 300px;" [(value)]="value" [(highValue)]="highValue"
                        (valueChange)="onChangeSlider($event)" [options]="options"></ngx-slider>
                </div>
                <div style="display: flex; flex-direction: column; font-family: Montserrat; margin-top: 32px;" [formGroup]="createCompetitionForm">
                    <span style="font-size: 14px; font-weight: 600; margin-bottom: 7px; letter-spacing: 2%; line-height: 17.07px;">Competition eligibility level</span>
                    <label style="font-size: 12px; font-weight: 400; margin-bottom: 2px;">
                        <input type="radio" name="level" formControlName="level" value="national_level"/>
                         National level
                    </label>
                    <label style="font-size: 12px; font-weight: 400;margin-bottom: 20px;">
                        <input type="radio" name="level" formControlName="level" value="state_level"/>
                        State level
                    </label>
                    <div *ngIf="createCompetitionForm.get('level').value === 'state_level'" style="display: flex; flex-direction: column; font-size: 14px; font-weight: 600;">
                        <label>
                            Select state
                        </label>
                        <div class="dropdown-container">
                            <div class="selected-option" (click)="toggleDropdown()">{{ selectedOption }}</div>
                            <mat-icon matDatepickerToggleIcon style="color: #386AF6; position: absolute; top: 8px; right: 0;">arrow_drop_down</mat-icon>
                            <div class="dropdown-list" *ngIf="showDropdown">
                              <div class="option" *ngFor="let state of indianStates" (click)="selectOption(state.name,state.code)">{{ state.name }}</div>
                            </div>
                        </div>
                    </div>
                  </div>
                <span class="form-sub-text-label" style="margin-top: 18px;margin-bottom: 6px;">No. of files allowed in
                    an entry</span>
                <mat-form-field [floatLabel]="'never'"
                    style="background-color: white;width: 23%;height:49px;text-align: center;border-radius: 8px; border: 1px #ECECEC solid; padding-right: 8px; margin-bottom: 10px;">
                    <mat-label class="drop-downtext">Choose number of entry</mat-label>
                    <mat-select [formControl]="numberOfentryForm">
                        <mat-option *ngFor="let count of numberOfentry" [value]="count">
                            {{count}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <span class="form-sub-text-label" style="margin-top: 18px;margin-bottom: 6px;">Type of Files</span>
                <div style="width: 28%;display: flex;">
                    <img src="assets/dumy-image.svg">
                    <span
                        style="width: 100%; color: #999999; font-size: 12px; font-family: Montserrat; font-weight: 400; letter-spacing: 0.20px; word-wrap: break-word">User
                        can upload JPEG, GIF or PNG images under 10 MB</span>
                </div>

                <span class="form-sub-text-label" style="margin-top: 18px;margin-bottom: 6px;">Certificate
                    Template</span>
                <img style="width: 160px;" src="assets/certificate.svg">
            </div>



            <div fxLayout="row" style="margin-top: 25px;justify-content: space-between; ">
                <span class="form-text-label">Schedule*</span>
                <img *ngIf="!toggleExpandIcon[4]" src="assets/plus.svg" style="cursor: pointer;"
                    (click)="expandField(4)">
                <img *ngIf="toggleExpandIcon[4]" src="assets/minus.svg" style="cursor: pointer;"
                    (click)="expandField(4)">
            </div>


            <div *ngIf="toggleExpandIcon[4]" fxLayout="row" fxLayoutAlign="start center" style="margin-top: 13px;">
                <button class="mx-1 col-md-3" style="display:inline-flex;justify-content: center;width: 30%;align-items: center; border: 1px solid #ECECEC;border-radius: 8px;
                    background: white; height: 56px;" id="reportrange" type="button">
                    <span>
                        <img src="assets/calender.svg">
                    </span>
                    <input matInput [min]="minStartDate" [matDatepicker]="campaignTwoPicker"
                        (dateChange)="onStartDateChange($event)" [formControl]="startDate">
                    <mat-datepicker-toggle matSuffix [for]="campaignTwoPicker">
                        <mat-icon matDatepickerToggleIcon style="color: #386AF6">arrow_drop_down</mat-icon>
                    </mat-datepicker-toggle>
                    <mat-datepicker #campaignTwoPicker></mat-datepicker>
                </button>
                <button
                    style="border: 1px solid #ECECEC;border-radius: 8px;height: 56px;padding-left: 10px;padding-right: 10px;background: white;">
                    <span>
                        <img src="assets/clock.svg" style="margin-right: 10px;">
                    </span>
                    <mat-form-field [floatLabel]="'never'">
                        <mat-label style="color: #0E0E0E;">Select Time</mat-label>
                        <mat-select [(value)]="selectedStartTime" (selectionChange)="startTimeTrigger($event)">
                            <mat-option *ngFor="let time of times" [value]="time">
                                {{time}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </button>
            </div>

            <div fxLayout="row" style="margin-top: 25px;justify-content: space-between; ">
                <span class="form-text-label">Add End Date*</span>
                <img *ngIf="!toggleExpandIcon[3]" src="assets/plus.svg" style="cursor: pointer;"
                    (click)="expandField(3)">
                <img *ngIf="toggleExpandIcon[3]" src="assets/minus.svg" style="cursor: pointer;"
                    (click)="expandField(3)">
            </div>



            <div *ngIf="toggleExpandIcon[3]" fxLayout="row" fxLayoutAlign="start center" style="margin-top: 13px;">
                <button class="mx-1 col-md-3" style="display:inline-flex;justify-content: center;width: 30%;align-items: center; border: 1px solid #ECECEC;border-radius: 8px;
                        background: white; height: 56px;" id="reportrange" type="button">
                    <span>
                        <img src="assets/calender.svg">
                    </span>
                    <input matInput [min]="minEndDate" [matDatepicker]="picker" (dateChange)="onEndDateChange($event)"
                        [formControl]="endDate">
                    <mat-datepicker-toggle matSuffix [for]="picker">
                        <mat-icon matDatepickerToggleIcon style="color: #386AF6">arrow_drop_down</mat-icon>
                    </mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </button>
                <button
                    style="border: 1px solid #ECECEC;border-radius: 8px;height: 56px;padding-left: 10px;padding-right: 10px;background: white;">
                    <span>
                        <img src="assets/clock.svg" style="margin-right: 10px;">
                    </span>
                    <mat-form-field [floatLabel]="'never'">
                        <mat-label style="color: #0E0E0E;">Select Time</mat-label>
                        <mat-select [(value)]="selectedEndTime" (selectionChange)="endTimeTrigger($event)">
                            <mat-option *ngFor="let time of times" [value]="time">
                                {{time}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </button>
            </div>

            <div fxLayout="column" style="margin-top: 20px;">
                <div fxLayout="column">
                    <div fxLayout="row" style="display: flex;flex-direction: row; justify-content: space-around;">
                        <button type="button" class="verify-btn" fxLayoutAlign="center center" (click)="submitFormData('DRAFT')"
                            style=" width: 235px;height: 45px;">Save as draft
                        </button>
                        <button *ngIf="!validateAllField()" type="button" class="verify-btn"
                            fxLayoutAlign="center center"
                            style="width: 235px;height: 45px;background: #C3D2FC; color:#fff">Generate Preview</button>
                        <button *ngIf="validateAllField()" type="button" class="verify-btn"
                            fxLayoutAlign="center center"
                            style="width: 235px;height: 45px;background: #386AF6; color:#fff"
                            (click)="genratePreview()">Generate Preview
                        </button>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <div fxFlex="25" class="preview-box">
        <div *ngIf="!previewDetails">
            <div style="background: #E1E9FE;padding: 10px; margin-bottom: 15px;">
                <span class="create-competition-text">Preview</span>
            </div>
            <span
                style="color: #0E0E0E; font-size: 14px; font-family: Montserrat; font-weight: 600; letter-spacing: 0.28px; word-wrap: break-word">Active
                Competition</span>
            <div style="width: 100%; height: 137px; position: relative; margin-top: 4px;">
                <div
                    style="width: 299px; height: 137px; left: 0px; top: 0px; position: absolute; background: white; box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.15); border-radius: 5px">
                </div>
                <div style="width: 113px; height: 137px; left: 0px; top: 0px; position: absolute; background: #F4F6FA">
                </div>
                <div
                    style="width: 26.32px; height: 26.32px; left: 43.34px; top: 55.34px; position: absolute; background: #C3D2FC; border: 0.33px #C3D2FC solid">
                </div>
                <div style="width: 166px; height: 109.57px; left: 128.62px; top: 13.93px; position: absolute">
                    <div
                        style="width: 166px; height: 69px; left: 0px; top: 0px; position: absolute; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 8px; display: inline-flex">
                        <div style="width: 116px; height: 9px; background: #ECECEC; border-radius: 10px"></div>
                        <div style="width: 148.15px; height: 9px; background: #ECECEC; border-radius: 10px"></div>
                        <div style="align-self: stretch; height: 5px; background: #ECECEC; border-radius: 10px"></div>
                        <div style="width: 148.15px; height: 9px; background: #ECECEC; border-radius: 10px"></div>
                    </div>
                    <div
                        style="width: 95.88px; height: 28px; left: 0.42px; top: 81.57px; position: absolute; background: #C3D2FC; border-radius: 24px; border: 1px #C3D2FC solid">
                    </div>
                </div>
            </div>

            <div
                style="width: 100%; height: 10%; justify-content: center; align-items: center; gap: 8px; display: inline-flex">
                <div
                    style="width: 36px; height: 36px; border-radius: 4px; border: 1px #386AF6 solid; justify-content: center; align-items: center; display: flex">
                    <div
                        style="text-align: center; color: #386AF6; font-size: 14px; font-family: Inter; font-weight: 600; word-wrap: break-word">
                        1</div>
                </div>
                <div
                    style="width: 36px; height: 36px; background: rgba(255, 255, 255, 0.80); border-radius: 4px; justify-content: center; align-items: center; display: flex">
                    <div
                        style="text-align: center; color: #386AF6; font-size: 14px; font-family: Inter; font-weight: 600; word-wrap: break-word">
                        2</div>
                </div>
            </div>
        </div>


        <!-- form here real review start -->


        <div *ngIf="previewDetails">
            <div *ngIf="previewPage == 0">
                <div
                    style="color: #0E0E0E; font-size: 14px; font-family: Montserrat; font-weight: 600; letter-spacing: 0.28px; word-wrap: break-word; margin-bottom: 20px;">
                    Active Competition</div>
                <div style="width: 100%;position: relative; margin-bottom: 54%;">
                    <div
                        style="width: 306px; height: 137px; left: 0px; top: 0px; position: absolute; background: #F4F6FA; box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.15); border-radius: 5px">
                    </div>
                    <div
                        style="width: 113px; height: 137px; left: -0px; top: 0px; position: absolute; background: linear-gradient(0deg, rgba(14, 14, 14, 0.20) 0%, rgba(14, 14, 14, 0.20) 100%)">
                        <img style="width: 113px;height: 136px;" [src]="photoUrl">
                    </div>
                    <div style="width: 180px; height: 110px; left: 129.03px; top: 13.50px; position: absolute">
                        <div
                            style="width: 180px; height: 50px; left: 0px; top: 0px; position: absolute; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 4px; display: inline-flex">
                            <div
                                style="width: 180px; color: #0E0E0E; font-size: 13px; font-family: Montserrat; font-weight: 700; line-height: 15.60px; word-wrap: break-word">
                                {{createCompetitionForm.get('name').value}}</div>
                            <div
                                style="color: #999999; font-size: 11px; font-family: Montserrat; font-weight: 500; line-height: 14.30px; word-wrap: break-word">
                                Last Date- {{createCompetitionForm.get('endTime').value | dateTransform: 'timestamp'}}
                            </div>
                        </div>
                        <div style="width: 95.88px; height: 28px; left: 0px; top: 82px; position: absolute">
                            <div
                                style="width: 95.88px; height: 28px; left: 0px; top: 0px; position: absolute; background: #386AF6; border-radius: 24px; border: 1px #386AF6 solid">
                            </div>
                            <div
                                style="left: 17.04px; top: 3.25px; position: absolute; text-align: center; color: white; font-size: 11px; font-family: Montserrat; font-weight: 600; line-height: 21px; word-wrap: break-word">
                                Send Entry</div>
                        </div>
                    </div>
                </div>
                <div style="width: 100%;justify-content: center; align-items: center; gap: 8px; display: inline-flex">
                    <div style="width: 36px; height: 36px; border-radius: 4px; border: 1px #386AF6 solid; justify-content: center; align-items: center; display: flex; cursor: pointer;"
                        (click)="onClickPreview(0)">
                        <div
                            style="text-align: center; color: #386AF6; font-size: 14px; font-family: Inter; font-weight: 600; word-wrap: break-word">
                            1</div>
                    </div>
                    <div style="width: 36px; height: 36px; background: rgba(255, 255, 255, 0.80); border-radius: 4px; justify-content: center; align-items: center; display: flex; cursor: pointer;"
                        (click)="onClickPreview(1)">
                        <div
                            style="text-align: center; color: #386AF6; font-size: 14px; font-family: Inter; font-weight: 600; word-wrap: break-word">
                            2</div>
                    </div>
                </div>
            </div>
            <div *ngIf="previewPage==1">
                <div
                    style="width: 100%; background: #E1E9FE; margin-bottom: 20px; padding-bottom: 12px;padding-top: 12px;padding-left: 12px;">
                    <div
                        style="color: #0E0E0E; font-size: 20px; font-family: Montserrat; font-weight: 600; letter-spacing: 0.04px; word-wrap: break-word">
                        Preview</div>
                </div>
                <div class="smartphone">
                    <div class="content">
                        <div fxLayout="row">
                            <img src="assets/back-preview.svg">
                            <div
                                style="color: #0E0E0E; font-size: 9.24px; font-family: Montserrat; font-weight: 700; line-height: 12.13px; word-wrap: break-word; margin-left: 3px;">
                                {{createCompetitionForm.get('name').value}}</div>
                        </div>
                        <img style="width: 100%; height: 34%; margin-top: 10px;" [src]="posterUrl" />
                        <div
                            style="width: 100%; height: 5%; padding-left: 7.51px; padding-right: 7.51px; padding-top: 4.04px; padding-bottom: 4.04px; background: #FFE9E9; border-radius: 4.62px; overflow: hidden; flex-direction: column; justify-content: flex-start; align-items: center; gap: 5.78px; display: inline-flex">
                            <div
                                style="width: 104px; text-align: center; color: #999999; font-size: 6.36px; font-family: Montserrat; font-weight: 500; line-height: 9.53px; word-wrap: break-word">
                                Last Date- {{createCompetitionForm.get('endTime').value | dateTransform: 'timestamp'}}
                            </div>
                        </div>
                        <div
                            style="width: 100%;margin-top: 10px; color: black; font-size: 6.93px; font-family: Montserrat; font-weight: 500; line-height: 9.01px; word-wrap: break-word "[innerHTML]="createCompetitionForm.get('deatailsBrief').value">
                        </div>
                        <img style="width: 100%;height: 28%;" *ngIf="detailsPicture" [src]="detailsPicture" >
                        <div style="width: 100%;margin-top: 10px; color: black; font-size: 6.93px; font-family: Montserrat; font-weight: 500; line-height: 9.01px; word-wrap: break-word"
                            [innerHTML]="createCompetitionForm.get('instruction').value">
                        </div>
                        <div
                            style="width: 100%; margin-top: 10px; padding: 8px; background: #EDF2FF; border-radius: 2.89px; justify-content: center; align-items: center; gap: 8px; display: inline-flex">
                            <div style="width: 516.81px; color: black; font-size: 6.93px; font-family: Montserrat; word-wrap: break-word"
                                [innerHTML]="createCompetitionForm.get('note').value">
                            </div>
                        </div>
                        <div style="width: 100%; text-align: center"><span
                                style="color: #999999; font-size: 6.93px; font-family: Montserrat; font-weight: 500; line-height: 9.01px; word-wrap: break-word">By
                                clicking on Upload, I agree to the Competition Zone </span><span
                                style="color: #386AF6; font-size: 6.93px; font-family: Montserrat; font-weight: 500; text-decoration: underline; line-height: 9.01px; word-wrap: break-word">Terms
                                and Conditions</span></div>
                        <div
                            style="width: 100%; height: 6%; background: #386AF6; border-radius: 14.44px; padding-top: 6px;">
                            <div
                                style="text-align: center; color: white; font-size: 9.24px; font-family: Montserrat; font-weight: 500; line-height: 12.71px; letter-spacing: 0.02px; word-wrap: break-word">
                                Upload</div>
                        </div>
                    </div>
                </div>
                <div style="width: 100%;justify-content: center; align-items: center; gap: 8px; display: inline-flex">
                    <div style="width: 36px; height: 36px; background: rgba(255, 255, 255, 0.80); border-radius: 4px; justify-content: center; align-items: center; display: flex; cursor: pointer;"
                        (click)="onClickPreview(0)">
                        <div
                            style="text-align: center; color: #386AF6; font-size: 14px; font-family: Inter; font-weight: 600; word-wrap: break-word">
                            1</div>
                    </div>
                    <div style="width: 36px; height: 36px; border-radius: 4px; border: 1px #386AF6 solid; justify-content: center; align-items: center; display: flex; cursor: pointer;"
                        (click)="onClickPreview(1)">
                        <div
                            style="text-align: center; color: #386AF6; font-size: 14px; font-family: Inter; font-weight: 600; word-wrap: break-word">
                            2</div>
                    </div>
                </div>
            </div>

            <button type="button" class="verify-btn" fxLayoutAlign="center center"
                style="width: 235px;height: 45px;background: #386AF6; color:#fff" (click)="submitFormData('PUBLISHED')">Publish
            </button>



        </div>


    </div>